import { logUsage } from 'owa-analytics';
import getCurrentZoomScale from 'owa-custom-zoom-store/lib/utils/getCurrentZoomScale';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export default function logEmbiggenZoomSettingDatapoint(): void {
    // User-initiated UI setting change: User changed zoom scale setting
    logUsage('EmbiggenZoomSetting', getModuleContextMailboxInfo(), {
        zoomScale: getCurrentZoomScale(),
    });
}
